import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthRoutePath } from '../../enums/auth-routes.enum';
import { CurrentUserService } from '../services/auth/current-user.service';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {
  constructor(
    private readonly currentUserService: CurrentUserService,
    private readonly router: Router
  ) {}

  canActivate(): boolean {
    const user = this.currentUserService.GetSession();

    if (user?.token) {
      if (this.currentUserService.requiresTwoFactorSetup(user)) {
        this.router.navigate([AuthRoutePath.TwoFactorSetup]);
        return false;
      }

      this.router.navigate(['/main/dashboard']);
      return false;
    }

    return true;
  }
}
